import {Component, OnInit,} from '@angular/core';
import {AbstractFields} from '../_abstract';
import {ResponsibleStaffService} from '../../services/wizard-form-groups-services/nested-forms/responsible-staff.service';
import {RoutesStorage} from '@helpers/routes.helper';
import {UserNamespace} from '@namespaces/user.namespace';
import {AuthService} from '@services/auth.service';

/* Поля шага визарда 'Ответственные лица' */

@Component({
    selector: 'responsible-staff-fields',
    templateUrl: './responsible-staff.component.html'

})
export class ResponsibleStaffFieldsComponent extends AbstractFields implements OnInit {

    public laboratoryFormUrl = RoutesStorage.Organization.laboratoryEdit;

    public canUpdateLaboratory = false;

    constructor(
        public staffService: ResponsibleStaffService,
        private authService: AuthService,
    ) {
        super();
    }

    ngOnInit() {
        super.ngOnInit();

        this.canUpdateLaboratory = this.authService.hasPermissions([UserNamespace.Permission.laboratoryUpdate]);
    }
}
